<template>
	<el-dialog
		title="售后详情"
		:visible="visible"
		width="820px"
		append-to-body
		@close="onClose"
	>
		<div v-loading="loading">
			<template v-if="detail">
				<div class="section">
					<div class="section-title">基础信息</div>
					<div class="kv-grid">
						<div class="kv"><span>售后单号</span><em>{{ detail.id || '-' }}</em></div>
						<div class="kv"><span>平台订单号</span><em>{{ detail.trade_no || '-' }}</em></div>
						<div class="kv"><span>状态</span><em>{{ detail.status_text || '-' }}</em></div>
						<div class="kv"><span>退款金额</span><em>{{ yuan(detail.refund_fee_for_buyer_yuan) }}</em></div>
						<div class="kv"><span>申请时间</span><em>{{ detail.create_time_str || '-' }}</em></div>
					</div>
				</div>

				<div class="section">
					<div class="section-title">消费者</div>
					<div v-if="detail.buyer" class="buyer-cell">
						<div class="avatar">
							<img v-if="detail.buyer.avatar" :src="detail.buyer.avatar" alt="" width="36" height="36">
							<i v-else class="el-icon-user"></i>
						</div>
						<div>
							<div>{{ detail.buyer.nickname || ('用户' + (detail.buyer.uid || '')) }}</div>
							<div class="sub">{{ detail.buyer.mobile || '-' }}</div>
						</div>
					</div>
					<div v-else class="empty-line">-</div>
				</div>

				<div class="section">
					<div class="section-title">申请信息</div>
					<div class="kv-grid">
						<div class="kv kv-block"><span>申请备注</span><em>{{ detail.buyer_apply_remark || '-' }}</em></div>
						<div class="kv kv-block"><span>退货地址</span><em>{{ detail.refund_address || '-' }}</em></div>
						<div class="kv kv-block"><span>同意备注</span><em>{{ detail.agree_remark || '-' }}</em></div>
					</div>
				</div>

				<div class="section">
					<div class="section-title">退货商品</div>
					<el-table :data="detail.items || []" size="small" border>
						<el-table-column label="商品" min-width="220">
							<template slot-scope="scope">
								<div class="goods-cell">
									<div class="thumb">
										<img v-if="scope.row.product_pic" :src="scope.row.product_pic" alt="" width="48" height="48">
										<i v-else class="el-icon-picture-outline"></i>
									</div>
									<div>
										<div>{{ scope.row.product_brand || '-' }} {{ scope.row.product_style_number || '' }}</div>
										<div class="sub">尺码 {{ scope.row.product_size || '-' }}</div>
									</div>
								</div>
							</template>
						</el-table-column>
						<el-table-column label="退货数量" width="90" align="center">
							<template slot-scope="scope">{{ scope.row.refund_num || 0 }}</template>
						</el-table-column>
						<el-table-column label="退货原因" min-width="140" align="center">
							<template slot-scope="scope">{{ refundReasonText(scope.row.refund_reason) }}</template>
						</el-table-column>
					</el-table>
				</div>

				<div class="section">
					<div class="section-title">处理日志</div>
					<el-timeline v-if="detail.logs && detail.logs.length">
						<el-timeline-item
							v-for="(log, idx) in detail.logs"
							:key="idx"
							:timestamp="log.create_time_str || ''"
							placement="top"
						>
							<div class="log-title">{{ log.content || '-' }}</div>
							<div v-if="log.operator_name" class="log-sub">操作人 {{ log.operator_name }}</div>
							<div v-if="log.remark" class="log-sub">{{ log.remark }}</div>
						</el-timeline-item>
					</el-timeline>
					<div v-else class="empty-line">暂无日志</div>
				</div>
			</template>
		</div>
	</el-dialog>
</template>

<script>
	import { MINI_CONFIG_API, getApiErrorMessage } from '@/constants/retailPlatform'

	export default {
		name: 'MiniprogramAfterSaleDialog',
		inject: ['appdata'],
		props: {
			visible: {
				type: Boolean,
				default: false,
			},
			serviceId: {
				type: [Number, String],
				default: 0,
			},
		},
		data() {
			return {
				loading: false,
				detail: null,
			}
		},
		watch: {
			visible(val) {
				if (val) {
					this.loadDetail()
				} else {
					this.detail = null
				}
			},
			serviceId() {
				if (this.visible) {
					this.loadDetail()
				}
			},
		},
		methods: {
			yuan(val) {
				return val || '-'
			},
			refundReasonText(id) {
				if (id === 0 || id === '0' || id == null || id === '') {
					return '-'
				}
				const list = (this.appdata && this.appdata.list && this.appdata.list.order_service_reason) || []
				for (let i = 0; i < list.length; i++) {
					if (Number(list[i].id) === Number(id)) {
						return list[i].name || String(id)
					}
				}
				return String(id)
			},
			onClose() {
				this.$emit('update:visible', false)
			},
			loadDetail() {
				const serviceId = Number(this.serviceId)
				if (!serviceId) {
					this.detail = null
					return
				}
				this.loading = true
				this.$axios.get(MINI_CONFIG_API.shopAfterSaleDetail, {
					params: { service_id: serviceId },
				}).then((res) => {
					if (!res.data || res.data.code != 0) {
						this.detail = null
						this.$message.error(getApiErrorMessage(res, '获取售后详情失败'))
						return
					}
					this.detail = res.data.data || null
				}).catch((err) => {
					console.log(err)
					this.detail = null
					this.$message.error('获取售后详情失败')
				}).finally(() => {
					this.loading = false
				})
			},
		},
	}
</script>

<style scoped lang="less">
	.section {
		margin-bottom: 16px;
	}

	.section-title {
		margin-bottom: 8px;
		font-size: 13px;
		font-weight: 600;
		color: #303133;
	}

	.kv-grid {
		display: flex;
		flex-wrap: wrap;
		gap: 8px 24px;
	}

	.kv {
		min-width: 220px;
		font-size: 13px;
		color: #606266;
		line-height: 1.6;

		span {
			margin-right: 8px;
			color: #909399;
		}

		em {
			font-style: normal;
			color: #303133;
		}
	}

	.kv-block {
		width: 100%;
		min-width: 0;
	}

	.buyer-cell,
	.goods-cell {
		display: flex;
		align-items: center;
		min-width: 0;
	}

	.avatar,
	.thumb {
		width: 36px;
		height: 36px;
		flex: none;
		margin-right: 10px;
		border-radius: 50%;
		background: #f5f6f8;
		overflow: hidden;
		display: flex;
		align-items: center;
		justify-content: center;

		img {
			width: 36px;
			height: 36px;
			object-fit: cover;
			display: block;
		}

		i {
			color: #c0c4cc;
		}
	}

	.thumb {
		width: 48px;
		height: 48px;
		border-radius: 4px;

		img {
			width: 48px;
			height: 48px;
		}
	}

	/deep/ .thumb img,
	/deep/ .avatar img {
		width: 100% !important;
		height: 100% !important;
		max-width: 48px;
		max-height: 48px;
		object-fit: cover;
		display: block;
	}

	.sub {
		margin-top: 2px;
		font-size: 12px;
		color: #909399;
	}

	.empty-line {
		font-size: 13px;
		color: #909399;
	}

	.log-title {
		font-size: 13px;
		color: #303133;
	}

	.log-sub {
		margin-top: 4px;
		font-size: 12px;
		color: #909399;
	}
</style>



// WEBPACK FOOTER //
// src/components/StoreConfig/miniprogram/afterSaleDialog.vue